// Define Launch Darkly flags here
// export const NAME_OF_LAUNCH_DARKLY_FLAG =
//   "launch-darkly-flag-name";
export const PAPERLESS_BILLING_TOGGLE_FLAG =
  "paperless-billing-toggle-nfe-demo";
export const AUTOPAY_DATE_SELECTION_FLAG = "autopay-date-selection-nfe-demo";
export const WALLET_SCREEN_V2_FLAG = "wallet-screen-v2";
export const ACCOUNT_LOADING_EXPERIENCE_FLAG = "nfe-account-loading-experience";
export const CLOUDFLARE_TURNSTILE_WALLET_FLAG = "cloudflare-turnstile-wallet";
export const CLOUDFLARE_TURNSTILE_CHECKOUT_FLAG =
  "cloudflare-turnstile-checkout";
